import { render, staticRenderFns } from "./TTable.vue?vue&type=template&id=5b53caff"
import script from "./TTable.vue?vue&type=script&lang=js"
export * from "./TTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports